export const moduleIndex = [
  {
    id: 'human-capability-edition',
    name: 'Human Capability Edition',
    summary: 'Understand capabilities and follow development over time',
  },
  { id: 'talent', name: 'Noetivra Talent', summary: 'Connect role requirements with demonstrated skills' },
  { id: 'clinical', name: 'Noetivra Clinical', summary: 'Review the clinical picture and its supporting knowledge' },
  { id: 'research', name: 'Noetivra Research', summary: 'Help researchers connect ideas' },
  { id: 'collaboration', name: 'Noetivra Collaboration', summary: 'Build a shared view across organizations' },
]

export const workspaceViews = [
  'Knowledge maps',
  'Comparison views',
  'Assessment profiles',
  'Timelines',
  'Review tools',
]

export const noetivraDemoUrl =
  'https://www.magicpatterns.com/c/rmhsjmkhewyqsdofk72aud/preview?hideToolbar=true&path=%2F'

export const workspacePanels = [
  {
    title: 'Citizen Workspace',
    body: 'Understand your development priorities, explore connected knowledge, practice judgment, manage goals, request services and follow your progress.',
  },
  {
    title: 'Administration Workspace',
    body: 'Coordinate support delivery, manage program intake, review cases, record decisions and monitor operational activity.',
  },
  {
    title: 'Connected workflows',
    body: 'A support request connects the citizen and administrator views. Requests, additional information, decisions and next steps remain visible throughout the process.',
  },
]

export const demoNotice = 'Interactive prototype · Fictional data · Changes saved in this browser.'

export const demoSwitchNote =
  'Explore Citizen and Administration views. This switch demonstrates workflows; it is not a secure account system.'

export const demoIncludes = [
  'Interactive workflows',
  'Knowledge graph',
  'Practice assessments',
  'Synthetic five-pillar profiles',
]

export const demoPlanned = [
  'Secure accounts',
  'Shared server storage',
  'Live agency integrations',
  'Production AI assessment',
]

export const talentExample = [
  {
    requirement: 'Planning',
    demonstrated: 'Created a workable schedule and identified dependencies.',
    followUp: 'Explore their response to a missed milestone.',
  },
  {
    requirement: 'Budget management',
    demonstrated: 'Described tracking project expenses.',
    followUp: 'Verify whether they owned the budget.',
  },
  {
    requirement: 'Handling setbacks',
    demonstrated: 'Explained a recovery plan and its tradeoffs.',
    followUp: 'Clarify their personal contribution.',
  },
]

export const systemFit = [
  {
    name: 'Semantic Knowledge Platform',
    role: 'Connects and governs institutional knowledge, evidence, relationships and provenance.',
    link: '/semantic-knowledge',
  },
  {
    name: 'Human Capability Framework',
    role: 'Structures assessment, development and review through CJI and NCJI, including NCJI’s five-pillar working model.',
    link: '/human-capability',
  },
  {
    name: 'Noetivra',
    role: 'The visual, interactive workspace connecting knowledge, assessment, development, services and institutional operations.',
    link: null,
  },
]
